import React from "react";
import PropTypes from "prop-types";
import onClickOutside from "react-onclickoutside";

// component is listening outside clicks and when it occurs execute
// close() callback
class ClickOutsideListener extends React.Component {
  static propTypes = {
    close: PropTypes.func
  };

  handleClickOutside(e) {
    if(this.props.close) {
      this.props.close(e);
    }
  }

  render() {
    return this.props.children;
  }
}

ClickOutsideListener.propTypes = {
  close: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired
};

export default onClickOutside(ClickOutsideListener);



// WEBPACK FOOTER //
// ./src/components/ClickOutsideListener.jsx